if (!customElements.get('spa-load-more')) {
  customElements.define(
    'spa-load-more',
    class SpaLoadMore extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.status = this.querySelector('[role="status"]');
        this.grid = document.getElementById(this.dataset.gridId);

        if (!this.button || !this.grid || !this.dataset.sectionId || !this.dataset.nextPage) {
          this.hidden = true;
          return;
        }

        this.buttonLabel = this.button.textContent.trim();
        this.button.addEventListener('click', () => this.loadNextPage());
      }

      async loadNextPage() {
        if (this.button.disabled) return;

        this.button.disabled = true;
        this.button.textContent = 'Loading…';
        this.setAttribute('aria-busy', 'true');

        try {
          const url = new URL(window.location.href);
          url.hash = '';
          url.searchParams.set('section_id', this.dataset.sectionId);
          url.searchParams.set('page', this.dataset.nextPage);

          const response = await fetch(url.toString(), {
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
          });

          if (!response.ok) throw new Error(`Unable to load products (${response.status})`);

          const responseDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
          const responseGrid = responseDocument.getElementById(this.dataset.gridId);
          const responseControl = responseDocument.querySelector(
            `spa-load-more[data-grid-id="${this.dataset.gridId}"]`,
          );
          const nextItems = responseGrid ? Array.from(responseGrid.children) : [];

          if (!nextItems.length) throw new Error('No additional products were returned');

          const fragment = document.createDocumentFragment();
          nextItems.forEach((item) => fragment.appendChild(item));
          this.grid.appendChild(fragment);

          const slider = this.grid.closest('slider-component');
          if (typeof slider?.resetPages === 'function') slider.resetPages();

          if (this.status) {
            this.status.textContent = `${nextItems.length} more designs loaded.`;
          }

          if (responseControl?.dataset.nextPage) {
            this.dataset.nextPage = responseControl.dataset.nextPage;
            this.button.disabled = false;
            this.button.textContent = this.buttonLabel;
          } else {
            this.hidden = true;
          }
        } catch (error) {
          console.error(error);
          this.button.disabled = false;
          this.button.textContent = 'Try again';
          if (this.status) this.status.textContent = 'More designs could not be loaded. Please try again.';
        } finally {
          this.removeAttribute('aria-busy');
        }
      }
    },
  );
}
